import type { IntlShape } from 'react-intl-next';

import type { ADFEntity } from '@atlaskit/adf-utils/types';
import { messages } from './messages';
import type { SnippetOwner } from './snippetTypes';

function filterValidAdfNodes(nodes: (ADFEntity | null | undefined)[]): ADFEntity[] {
	return nodes.filter((node): node is ADFEntity => node !== undefined && node !== null);
}

export const parseSnippetContent = (content: string): ADFEntity | ADFEntity[] | undefined => {
	try {
		const parsedContent = JSON.parse(content);

		// Handle fragment (array of nodes without doc wrapper)
		if (Array.isArray(parsedContent)) {
			return filterValidAdfNodes(parsedContent);
		}

		// Handle single node or doc node
		const adfContent = parsedContent as ADFEntity;

		if (adfContent.type === 'doc' && Array.isArray(adfContent.content)) {
			return filterValidAdfNodes(adfContent.content);
		}

		return adfContent;
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error('Error processing snippet ADF:', error);
		return undefined;
	}
};

export const extractSnippetKeywords = (name: string, intl: IntlShape): string[] => {
	const nameKeywords = name
		.split(/\s+/)
		.map((word) => word.toLowerCase().trim())
		.filter((word) => word.length > 0);

	const templateKeyword = intl.formatMessage(messages.template).toLowerCase();
	const allKeywords = [...nameKeywords, templateKeyword];
	return Array.from(new Set(allKeywords));
};

export const createSnippetDescription = (createdBy: SnippetOwner, intl: IntlShape): string => {
	const name = createdBy.displayName || createdBy.accountId;
	return intl.formatMessage(messages.snippetBy, { name });
};
